import {
  ILoginPayload,
  loginWithProvider,
  OAUTH_GRANT_TYPE,
  PRODUCT_TYPE,
  SOCIAL_LOGIN_PROVIDER,
} from '../../../../modules/auth'
import { DEFAULT_LOCALE, LOCALE_KEY, LocaleType } from '../../../../modules/i18n/config'
import { SOCIAL_LOGIN_PREFIX } from '../../../../modules/vars'
import useAppRouter from '../../common/useAppRouter'

// from node_modules/react-kakao-login/lib/types.d.ts

interface LoginResponse {
  token_type: string
  access_token: string
  expires_in: string
  refresh_token: string
  refresh_token_expires_in: number
  scope: string
}

const useKakaoLogin = (locale: LocaleType, isMobile: boolean) => {
  const router = useAppRouter()
  const handleKakaoLogin = async (result: { response: LoginResponse }) => {
    const payload: Omit<ILoginPayload, 'google_token_type'> = {
      grant_type: OAUTH_GRANT_TYPE.PASSWORD,
      username: SOCIAL_LOGIN_PREFIX + SOCIAL_LOGIN_PROVIDER.KAKAO,
      password: result.response.access_token,
      locale: locale == LOCALE_KEY ? DEFAULT_LOCALE : locale,
      product_type: PRODUCT_TYPE.PLUS,
    }
    await loginWithProvider(router, payload, isMobile, null, SOCIAL_LOGIN_PROVIDER.KAKAO)
  }

  return handleKakaoLogin
}

export default useKakaoLogin
